import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { roles } from "utils/constant";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import {
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ArrowUpIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from "@heroicons/react/24/outline";
import { get_file_url } from "utils/lib-utils";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { Button } from "@heroui/react";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";

// Modern select styles matching other pages
const expenseSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "10px",
    borderColor: state.isFocused ? "#0077B6" : "#e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(0, 119, 182, 0.2)" : "none",
    padding: "0px 2px",
    minHeight: "32px",
    fontSize: "13px",
    transition: "all 0.2s ease",
    "&:hover": { borderColor: "#0077B6" },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: "0 6px",
  }),
  input: (base: any) => ({
    ...base,
    margin: "0px",
    padding: "0px",
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: "32px",
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected ? "#0077B6" : state.isFocused ? "#e0f2fe" : "white",
    color: state.isSelected ? "white" : "#1e293b",
    fontSize: "13px",
    padding: "6px 10px",
    cursor: "pointer",
  }),
  menu: (base: any) => ({
    ...base,
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
    zIndex: 9999,
  }),
  menuPortal: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
  placeholder: (base: any) => ({
    ...base,
    color: "#94a3b8",
    fontSize: "13px",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "#1e293b",
    fontSize: "13px",
  }),
};

const ExpenseVouchureList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const [tableData, setTableData] = useState<any>([]);
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    date: {
      $gte: moment().startOf("day"),
      $lte: moment().endOf("day"),
    },
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [sortStat, setSortStat] = useState<any>({});

  const [selectedAgent, setSelectedAgent] = useState({ id: null, name: "--- Select All ---" });
  const [allAgents, setAllAgents] = useState([]);

  const [selectedSubbranch, setSelectedSubbranch] = useState<any>(null);
  const [subbranchOptions, setSubBranchOptions] = useState<any>([]);

  const [selectedVouchers, setSelectedVouchers] = useState<any>([]);
  const [selectedTotal, setSelectedTotal] = useState<any>(0);
  const [firstVoucherStatus, setFirstVoucherStatus] = useState<string>("");

  const [selectedStatus, setSelectedStatus] = useState({ value: "", label: "--- Select All ---" });
  const [allStatusList, setAllStatusList] = useState([
    { value: "", label: "--- Select All ---" },
    { value: "PENDING", label: "Pending By Both" },
    { value: "APPROVED", label: "Approve By Manager, Pending By Acc." },
    { value: "DISBURSED", label: "Disbursed" },
    { value: "REJECTED", label: "Rejected / Cancel" },
  ]);

  useEffect(() => {
    let total = 0;
    let status = "";
    if (tableData.length) {
      tableData.forEach((t) => {
        if (selectedVouchers.includes(t.id)) {
          total += Number(t.expense);
          status = t.status;
        }
      });
      setSelectedTotal(total);
      setFirstVoucherStatus(status);
    }
  }, [selectedVouchers]);

  useQuery(["SubBranchesListApi_expense"], () => ListCommanWay("/admin/subbranch/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = data.data.data.map((p) => ({ value: p.id, label: p.branch_name }));
        setSubBranchOptions(opt);
      }
    },
  });

  useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      console.log("userD", userD.state.user);
      if (userD.state.user.username == "KIRANG") {
        mutateListAgents({ subbranch: [43, 46, 53, 55, 54, 56] });
      } else if (userD.state.user.username == "sarvanaa") {
        mutateListAgents({ subbranch: [53, 55] });
      } else if (userD.state.user.roleName == roles.SUPER_ADMIN) {
        mutateListAgents({ subbranch: undefined });
      } else if (userD.state.user.roleName == roles.SUBBRANCH_ADMIN) {
        mutateListAgents({ subbranch: userD.state.user?.subbranch });
      } else {
        mutateListAgents({ subbranch: undefined });
      }
    }
  }, []);

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_expense_vouchure_list"],
    () =>
      ListCommanWay("/admin/expense_vouchure/list", query, {
        include: ["_user"],
      }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
          setSortStat({});
          setSelectedVouchers([]);
          setSelectedTotal(0);
          setFirstVoucherStatus("");
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    },
  );

  const { mutate: mutateListAgents }: any = useMutation(
    (qry: any) =>
      ListCommanWay(
        "/admin/user/list",
        {
          subbranch: qry?.subbranch,
          isActive: true,
        },
        { paginate: 100000 },
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setAllAgents([{ id: null, name: "--- Select All ---" }, ...data.data.data]);
        }
      },
      onError: (data: any) => {},
    },
  );

  const {
    mutate,
    isLoading: isloadingPrice,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => UpdateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        refetch();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });
  const onStateChange = (id: any, status) => {
    Swal.fire({
      title: "Are you sure!",
      text: "Changing Status to : " + status,
      icon: "info",
      confirmButtonText: "Yes",
      showCancelButton: true,
      html:
        '<input id="user_remark" class="swal2-input" placeholder="Enter Remark">' +
        '<input id="transactionNo" class="swal2-input" placeholder="Transaction No">',
    }).then((x) => {
      if (x.isConfirmed) {
        let updateData: any = {
          account_remark: undefined,
          transactionNo: (document.getElementById("transactionNo") as any).value,
          account_date: undefined,
          status: status,
        };
        if (userDetails.role_name == 9 || userDetails.role_name == 3 || ["KIRANG", "sarvanaa"].includes(userDetails.username)) {
          updateData.admin_remark = (document.getElementById("user_remark") as any).value;
          updateData.admin_date = new Date();
        } else {
          updateData.account_remark = (document.getElementById("user_remark") as any).value;
          updateData.account_date = new Date();
          if (updateData.transactionNo == "") {
            delete updateData.transactionNo;
          }
        }
        if (typeof id == "object") {
          mutate({
            url: "/admin/expense_vouchure/updateBulk",
            data: {
              filter: { id: selectedVouchers },
              data: updateData,
            },
          });
        } else {
          mutate({
            url: "/admin/expense_vouchure/update/" + id,
            data: updateData,
          });
        }
      }
    });
  };

  const onGstInfoChange = (id: any) => {
    Swal.fire({
      title: "Add GST Details!",
      icon: "info",
      confirmButtonText: "Yes",
      showCancelButton: true,
      html:
        //inputs for cgst, sgst, igst
        '<input style="height: 1.5em; margin: 4px;" id="cgst" class="swal2-input" placeholder="CGST (%)">' +
        '<input style="height: 1.5em; margin: 4px;" id="sgst" class="swal2-input" placeholder="SGST (%)">' +
        '<input style="height: 1.5em; margin: 4px;" id="igst" class="swal2-input" placeholder="IGST (%)">' +
        '<input style="height: 1.5em; margin: 4px;" id="customerGstNo" class="swal2-input" placeholder="Customer GST No">' +
        '<input style="height: 1.5em; margin: 4px;" id="airfieldGstNo" class="swal2-input" placeholder="Airfield GST NO">',
    }).then((x) => {
      if (x.isConfirmed) {
        let updateData: any = {
          cgst: Number((document.getElementById("cgst") as any).value) || 0,
          sgst: Number((document.getElementById("sgst") as any).value) || 0,
          igst: Number((document.getElementById("igst") as any).value) || 0,
          customerGstNo: (document.getElementById("customerGstNo") as any).value || "",
          airfieldGstNo: (document.getElementById("airfieldGstNo") as any).value || "",
        };
        if (typeof id == "object") {
          mutate({
            url: "/admin/expense_vouchure/updateBulk",
            data: {
              filter: { id: selectedVouchers },
              data: updateData,
            },
          });
        } else {
          mutate({
            url: "/admin/expense_vouchure/update/" + id,
            data: updateData,
          });
        }
      }
    });
  };

  useEffect(() => {
    refetch();
  }, [query]);

  const handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);

    let userFilter: any = undefined;
    if (selectedAgent.id) {
      userFilter = selectedAgent.id;
    } else if (selectedSubbranch && allAgents.length > 1) {
      // When subbranch is selected but no specific employee, pass all user ids from that subbranch
      const userIds = allAgents.filter((a: any) => a.id !== null).map((a: any) => a.id);
      if (userIds.length > 0) userFilter = userIds;
    }

    setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
      },
      user: userFilter,
      status: selectedStatus.value == "" ? undefined : selectedStatus.value,
    });
  };

  const tableRef = useRef(null);
  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Expense Vouchure Report.xlsx");
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <div className="bg-gradient-to-br from-purple-400 via-blue-50 to-primary/50 py-2 px-2 font-inter flex-1">
      {/* ═══════════ HEADER BAR ═══════════ */}
      <div className="mx-auto mb-2">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl px-3 py-2 shadow-xl shadow-slate-200/50">
          <div className="flex items-center justify-center gap-3">
            <h1 className="text-base font-bold bg-gradient-to-r from-primary to-amber-600 bg-clip-text text-transparent uppercase">
              Expense Voucher
            </h1>
          </div>
        </div>
      </div>

      {/* ═══════════ FILTERS CARD ═══════════ */}
      <div className="mx-auto mb-2">
        <div className="shadow-xl shadow-slate-200/50 bg-white/80 backdrop-blur-sm overflow-visible rounded-xl">
          <div className="px-3 py-2">
            <div className="flex gap-3 items-center flex-wrap">
              {(userDetails.roleName == roles.SUPER_ADMIN || userDetails.roleName == roles.MANAGER) && (
                <div className="flex flex-col gap-1">
                  <label className="text-[11px] font-medium text-slate-500">Subbranch</label>
                  <Select
                    className="min-w-[180px]"
                    styles={expenseSelectStyles}
                    options={subbranchOptions}
                    onChange={(e: any) => {
                      setSelectedSubbranch(e);
                      setSelectedAgent({ id: null, name: "--- Select All ---" });
                      mutateListAgents({ subbranch: e?.value || undefined });
                    }}
                    value={selectedSubbranch}
                    isClearable
                    placeholder="All Subbranches"
                    menuPortalTarget={document.body}
                  />
                </div>
              )}

              {([1, 2, 3, 5, 9].includes(userDetails.role_name) || ["KIRANG", "sarvanaa"].includes(userDetails.username)) && (
                <div className="flex flex-col gap-1">
                  <label className="text-[11px] font-medium text-slate-500">Employee</label>
                  <Select
                    className="min-w-[180px]"
                    styles={expenseSelectStyles}
                    options={allAgents}
                    onChange={(e: any) => setSelectedAgent(e)}
                    value={selectedAgent}
                    getOptionValue={(e) => e.id + ""}
                    getOptionLabel={(e) => e.name}
                    menuPortalTarget={document.body}
                  />
                </div>
              )}

              <div className="flex flex-col gap-1">
                <label className="text-[11px] font-medium text-slate-500">Status</label>
                <Select
                  className="min-w-[200px]"
                  styles={expenseSelectStyles}
                  options={allStatusList}
                  onChange={(e: any) => setSelectedStatus(e)}
                  value={selectedStatus}
                  menuPortalTarget={document.body}
                />
              </div>

              <div className="self-start">
                <AfDateRangePicker
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  label="From - To Date"
                  className="bg-white"
                />
              </div>

              <Button size="sm" color="success" variant="solid" className="h-8 text-xs font-semibold text-white" onPress={handleSubmit}>
                Search
              </Button>
              <Button size="sm" color="primary" variant="flat" className="h-8 text-xs font-semibold" onPress={exportToExcel}>
                Excel Export
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════ BULK ACTIONS CARD ═══════════ */}
      {selectedTotal >= 0 && (
        <div className="mx-auto mb-2">
          <div className="shadow-xl shadow-slate-200/50 bg-white/80 backdrop-blur-sm overflow-visible rounded-xl px-3 py-2">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <span className="text-sm font-bold text-slate-800">
                  Selected Total: <span className="text-lg text-primary2">{selectedTotal}</span>
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  size="sm"
                  color="success"
                  variant="solid"
                  className="h-7 text-xs font-semibold text-white"
                  isDisabled={selectedTotal == 0}
                  onPress={() => {
                    onStateChange(selectedVouchers, userDetails.role_name == 9 || userDetails.role_name == 3 ? "APPROVED" : "DISBURSED");
                  }}
                >
                  {userDetails.role_name == 9 || userDetails.role_name == 3 ? "Bulk Approve" : "Bulk Disbursed"}
                </Button>
                <Button
                  size="sm"
                  color="danger"
                  variant="solid"
                  className="h-7 text-xs font-semibold"
                  isDisabled={selectedTotal == 0}
                  onPress={() => {
                    onStateChange(selectedVouchers, "REJECTED");
                  }}
                >
                  Bulk Reject
                </Button>
                <Button
                  size="sm"
                  color="primary"
                  variant="bordered"
                  className="h-7 text-xs font-semibold"
                  onPress={() => {
                    onGstInfoChange(selectedVouchers);
                  }}
                >
                  Add GST Info
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════ TABLE CARD ═══════════ */}
      <div className="mx-auto">
        <div className="shadow-xl shadow-slate-200/50 bg-white/80 backdrop-blur-sm overflow-visible rounded-xl">
          <div className="overflow-x-auto">
            <table className="w-full font-inter text-sm" id="myTable" ref={tableRef}>
              <thead>
                <tr className="bg-gradient-to-r from-slate-50 to-slate-100">
                  {([1, 2, 3, 5, 9].includes(userDetails.role_name) || ["KIRANG", "sarvanaa"].includes(userDetails.username)) && (
                    <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                      <input
                        type="checkbox"
                        className="w-4 h-4 rounded border-slate-300 text-primary2 focus:ring-primary2/20 mr-1"
                        onChange={(ip) => {
                          let checked_ = ip.target.checked;
                          if (checked_ && tableData.length) {
                            let firstStatus = tableData[0].status;
                            let obj = [];
                            tableData.forEach((x) => {
                              if (x.status == firstStatus) {
                                obj.push(x.id);
                              }
                            });
                            setSelectedVouchers(obj);
                          } else {
                            setSelectedVouchers([]);
                          }
                        }}
                        checked={selectedVouchers.length}
                      />
                    </th>
                  )}
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Txn No
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    User {GET_SORT_ICON("_user.name", "asc")}
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Head
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Ref No
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Amount
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider w-28">
                    Expense Date {GET_SORT_ICON("date", "")}
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider w-28">
                    Submit Date {GET_SORT_ICON("createdAt", "")}
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider w-24">
                    Image
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Status {GET_SORT_ICON("status", "")}
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Manager Remark
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    Account Remark
                  </th>
                  <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider">
                    GST Info
                  </th>
                  {[1, 2, 3, 5, 9].includes(userDetails.role_name) && (
                    <th className="border-b border-slate-200 px-3 py-2 text-left text-[11px] font-semibold text-slate-600 uppercase tracking-wider w-24">
                      Action
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {tableData.map((r) => {
                  const statusColor =
                    r.status === "APPROVED"
                      ? "bg-blue-50 border-l-2 border-l-blue-400"
                      : r.status === "REJECTED"
                        ? "bg-red-50 border-l-2 border-l-red-400"
                        : r.status === "DISBURSED"
                          ? "bg-green-50 border-l-2 border-l-green-400"
                          : "bg-white border-l-2 border-l-amber-400";
                  return (
                    <tr
                      key={r.id}
                      className={`${
                        selectedVouchers.includes(r.id) ? "bg-primary2/10" : statusColor
                      } hover:bg-slate-50/80 transition-colors`}
                    >
                      {([1, 2, 3, 5, 9].includes(userDetails.role_name) || ["KIRANG", "sarvanaa"].includes(userDetails.username)) && (
                        <td className="border-b border-slate-100 px-3 py-1.5">
                          {r.status != "REJECTED" &&
                          (selectedVouchers.length == 0 || (selectedVouchers.length && firstVoucherStatus == r.status)) ? (
                            <input
                              type="checkbox"
                              className="w-4 h-4 rounded border-slate-300 text-primary2 focus:ring-primary2/20"
                              onChange={(ip) => {
                                if (ip.target.checked) {
                                  let obj = [...selectedVouchers];
                                  obj.push(r.id);
                                  setSelectedVouchers(obj);
                                } else {
                                  let obj = [...selectedVouchers];
                                  const index = obj.indexOf(r.id);
                                  if (index > -1) {
                                    obj.splice(index, 1);
                                  }
                                  setSelectedVouchers(obj);
                                }
                              }}
                              checked={selectedVouchers.includes(r.id)}
                            />
                          ) : (
                            <span className="text-slate-300">-</span>
                          )}
                        </td>
                      )}

                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] text-slate-700">{r.transactionNo}</td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] font-medium text-slate-800">{r._user?.name}</td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] text-slate-600">{r.remark}</td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] text-slate-600">{r.refNo}</td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] font-semibold text-slate-800">{r.expense}</td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] text-slate-600">{r.date}</td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[13px] text-slate-600">{r.createdAt}</td>

                      <td className="border-b border-slate-100 px-3 py-1.5">
                        <PhotoProvider
                          toolbarRender={({ rotate, onRotate }) => {
                            return (
                              <div className="flex gap-4 bg-gray-200/25 p-2 rounded-md">
                                <button onClick={() => onRotate(rotate - 90)}>
                                  <ArrowUturnLeftIcon className="PhotoView-Slider__toolbarIcon fill-none h-6 p-0" />
                                </button>
                                <button onClick={() => onRotate(rotate + 90)}>
                                  <ArrowUturnRightIcon className="PhotoView-Slider__toolbarIcon fill-none h-6 p-0" />
                                </button>
                              </div>
                            );
                          }}
                        >
                          {r.image ? (
                            r.image.split(",").map((i) => {
                              return (
                                <div className="flex mb-1 bg-slate-100 rounded-lg p-1 items-center" key={i}>
                                  <PhotoView src={get_file_url(i)}>
                                    <img
                                      width={60}
                                      className="h-[60px] object-cover rounded-md cursor-pointer hover:opacity-80 transition-opacity"
                                      src={get_file_url(i)}
                                    />
                                  </PhotoView>
                                  <a href={get_file_url(i)} target="_blank" rel="noopener noreferrer">
                                    <ArrowTopRightOnSquareIcon className="h-4 ml-1.5 text-slate-400 hover:text-primary2 transition-colors" />
                                  </a>
                                </div>
                              );
                            })
                          ) : (
                            <span className="text-slate-300">-</span>
                          )}
                        </PhotoProvider>
                      </td>
                      <td className="border-b border-slate-100 px-3 py-1.5">
                        <span
                          className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold ${
                            r.status === "APPROVED"
                              ? "bg-blue-100 text-blue-700"
                              : r.status === "REJECTED"
                                ? "bg-red-100 text-red-700"
                                : r.status === "DISBURSED"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-amber-100 text-amber-700"
                          }`}
                        >
                          {r.status}
                        </span>
                      </td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[12px] text-slate-600">
                        {r.admin_remark}
                        {r.admin_date && (
                          <div className="text-[10px] font-semibold text-slate-400 mt-0.5">
                            {moment(r.admin_date).format("DD-MM-YYYY HH:mm")}
                          </div>
                        )}
                      </td>
                      <td className="border-b border-slate-100 px-3 py-1.5 text-[12px] text-slate-600">
                        {r.account_remark}
                        {r.account_date && (
                          <div className="text-[10px] font-semibold text-slate-400 mt-0.5">
                            {moment(r.account_date).format("DD-MM-YYYY HH:mm")}
                          </div>
                        )}
                      </td>
                      <td className="border-b border-slate-100 px-3 py-1.5">
                        {r.cgst || r.sgst || r.igst ? (
                          <div className="text-[11px] font-semibold text-slate-600 space-y-0.5">
                            <div className="flex gap-2">
                              <span className="text-slate-400">C:</span>
                              {r.cgst || 0}
                              <span className="text-slate-400">S:</span>
                              {r.sgst || 0}
                              <span className="text-slate-400">I:</span>
                              {r.igst || 0}
                            </div>
                            <div className="text-[10px] text-slate-400 border-t border-slate-100 pt-0.5">
                              AF: {r.airfieldGstNo || "-"} | C: {r.customerGstNo || "-"}
                            </div>
                          </div>
                        ) : (
                          <span className="text-slate-300 text-[12px]">-</span>
                        )}
                      </td>
                      {(["KIRANG", "sarvanaa"].includes(userDetails.username) || [1, 2, 3, 5, 9].includes(userDetails.role_name)) && (
                        <td className="border-b border-slate-100 px-3 py-1.5">
                          <div className="flex flex-col gap-1">
                            {r.status ==
                              (userDetails.role_name == 9 ||
                              userDetails.role_name == 3 ||
                              ["KIRANG", "sarvanaa"].includes(userDetails.username)
                                ? "PENDING"
                                : "APPROVED") && (
                              <Button
                                size="sm"
                                color="success"
                                variant="flat"
                                className="h-6 text-[11px] font-semibold min-w-0"
                                onPress={() => {
                                  onStateChange(
                                    r.id,
                                    userDetails.role_name == 9 ||
                                      userDetails.role_name == 3 ||
                                      ["KIRANG", "sarvanaa"].includes(userDetails.username)
                                      ? "APPROVED"
                                      : "DISBURSED",
                                  );
                                }}
                              >
                                {userDetails.role_name == 9 ||
                                userDetails.role_name == 3 ||
                                ["KIRANG", "sarvanaa"].includes(userDetails.username)
                                  ? "Approve"
                                  : "Disburse"}
                              </Button>
                            )}
                            {r.status != "REJECTED" && (
                              <Button
                                size="sm"
                                color="danger"
                                variant="flat"
                                className="h-6 text-[11px] font-semibold min-w-0"
                                onPress={() => {
                                  onStateChange(r.id, "REJECTED");
                                }}
                              >
                                Reject
                              </Button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseVouchureList;
